import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { map } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { WIZTASKS_AUTH_TOKEN_KEY, decodeJwtPayload } from '../utils/jwt.util';

/**
 * WizCode operator console (/admin/subscriptions, /admin/plans). Strictly the
 * instance super-admin — NOT workspace admins.
 */
export const systemAdminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const jwtOperator = (() => {
    try {
      const raw = typeof localStorage !== 'undefined' ? localStorage.getItem(WIZTASKS_AUTH_TOKEN_KEY) : null;
      if (!raw) return false;
      const p = decodeJwtPayload(raw.trim());
      const sa = p?.is_super_admin;
      return sa === true || sa === 1 || Number(sa ?? 0) === 1;
    } catch {
      return false;
    }
  })();

  return auth.loadUser().pipe(
    map(() => (jwtOperator || auth.isOperator() ? true : router.createUrlTree(['/dashboard']))),
  );
};
